export function snakeToNormal(str: string) {
  return str.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}

export function shortenText(str: string, length: number) {
  return str.length > length ? str.substring(0, length) + '...' : str;
}
